var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
    _c(
      "p",
      [_c("b-icon", { attrs: { icon: "emoticon-sad", size: "is-large" } })],
      1
    ),
    _c("p", [_vm._v(_vm._s(_vm.$t("messages.data_not_found")))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }